<template>
  <!-- The label is for screen readers and tooltips -->
  <IconButton icon="pencil" variant="ghost" size="medium" aria-label="Edit" title="Edit" data-manage-action />
</template>

<script setup lang="ts">
import { IconButton } from '@tallo/design-system';
</script>
